// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ExploreButton (Web Applications) component should render without throwing an error 1`] = `
<ContextConsumer>
  <Component />
</ContextConsumer>
`;
